export enum StudentViewEnum {
  StudentList,
  StudentProgress,
}
